import { withTranslation, WithTranslation } from 'react-i18next';
import * as React from 'react';
import { Component } from 'react';
import { RequestDto, RequestsStore } from 'stores/requests/requests-store';
import RequestFormView from 'site/pages/requests/request-form/request-form';
import { connect } from 'redux-scaffolding-ts';
import { buildRequestFormViewModel } from 'stores/requests/request-form-store';
import { EventFormStore, EventFormViewModel } from 'stores/events/event-form-store';
import { ChangeEventsStore } from 'stores/events/events-store';
import TailwindCancelEventPopup from 'site/pages/events/event-form/popups/cancel-event-popup/cancel-event-popup-tw';

interface EventRequestsContainerProps extends WithTranslation {
  selectedEventFormViewModel: EventFormViewModel;
  readOnly: boolean;
  requestsStore?: RequestsStore;
  eventFromStore?: EventFormStore;
  changeEventStore?: ChangeEventsStore;
  fromEventTab: boolean;
}

export interface EventRequestsContainerState {
  openedRequestForm: RequestDto;
  showRemovalRequestEventPopup: boolean;
  removedRequest: RequestDto;
  selectedEvent: EventFormViewModel;
}

@connect(['requestsStore', RequestsStore], ['eventFromStore', EventFormStore])
class EventRequestsContainer extends Component<EventRequestsContainerProps, EventRequestsContainerState> {
  state: EventRequestsContainerState = {
    selectedEvent: this.props.selectedEventFormViewModel,
    openedRequestForm: null,
    showRemovalRequestEventPopup: false,
    removedRequest: null
  };

  onCloseRequestForm = (): void => this.setState({ openedRequestForm: null });

  handleOnRequestClicked = (selectedRequestId: string): void => {
    this.props.requestsStore.getById(selectedRequestId).then(request => this.setState({ openedRequestForm: request }));
  };

  handleOnRemoveRequestClick = (removedRequest: RequestDto) => this.setState({ showRemovalRequestEventPopup: true, removedRequest });

  private handleOnChangeEventRequest = (request: RequestDto): void => {
    const { item: event } = this.props.eventFromStore.state;

    this.props.eventFromStore.removeRequestFromEvent(request.id);

    const requests = event.requests.filter(x => request.id !== x.id);

    const currentRequestsStudentsIds = requests
      .map(x => x.students)
      .flat()
      .map(s => s.id);

    const removeRequestStudentsIds = event.requests.firstOrDefault(x => request.id === x.id).students.map(s => s.id);

    const studentToRemoveIds = removeRequestStudentsIds.filter(x => !currentRequestsStudentsIds.includes(x));
    const students = event.students.filter(({ id }) => !studentToRemoveIds.includes(id));
    const studentsRequested = event.studentsRequested - request.studentsNumber;

    this.props.eventFromStore.change({ requests, students, studentsRequested, studentsAssigned: students.length });

    this.setState({ showRemovalRequestEventPopup: false, removedRequest: null });
  };

  onCancelOrError = () => this.setState({ showRemovalRequestEventPopup: false, removedRequest: null });

  public render() {
    const { removedRequest, showRemovalRequestEventPopup, openedRequestForm } = this.state;
    const { fromEventTab, readOnly } = this.props;
    const { requests, parentRequest } = this.state.selectedEvent;

    return (
      <>
        {!removedRequest ? (
          <div
            onClick={() => {}}
            className={`bg-white shadow p-4 mt-4 overflow-y-auto transition-all duration-300 max-h-[300px]'
          }`}
          >
            {(requests || []).map((request, idx) => {
              return (
                <div key={`${request.languageId}_${idx}`} className="border-l-4 p-3 mb-2 cursor-pointer shadow-md">
                  <p className="text-xs text-gray-500">{request.friendlyId}</p>
                  <div className="flex items-center gap-2" onClick={() => this.handleOnRequestClicked(request.id)}>
                    <h4 className="text-black-600 font-semibold">{request.title}</h4>
                  </div>
                  <p className="text-sm ">
                    {request.requestingLocationName
                      ? request.requestLocation.code !== 'XXXX' && request.requestLocation.code !== 'XXXXX'
                        ? request.requestingLocationName + ' - ' + request.requestingLocationCountryName
                        : request.requestingLocationName
                      : ''}
                  </p>
                  <p className="text-sm">{request.requestOwner && `${request.requestOwner.lastName}, ${request.requestOwner.firstName}`}</p>

                  {!readOnly && parentRequest.id !== request.id ? (
                    <div key={`${idx}_eye`}>
                      <div className="flex-end" onClick={() => this.handleOnRemoveRequestClick(request)}>
                        <svg
                          className="w-6 h-6 text-gray-800 dark:text-white"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M3 15v3c0 .5523.44772 1 1 1h16c.5523 0 1-.4477 1-1v-3M3 15V6c0-.55228.44772-1 1-1h16c.5523 0 1 .44772 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-5.5061-7.4939L12 10m0 0 1.5061-1.50614M12 10l1.5061 1.5061M12 10l-1.5061-1.50614"
                          />
                        </svg>
                      </div>
                    </div>
                  ) : (
                    <div key={`${idx}_eye`} />
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <TailwindCancelEventPopup
            cancelRequest
            request={removedRequest}
            open={showRemovalRequestEventPopup}
            onSuccess={() => this.handleOnChangeEventRequest(removedRequest)}
            onCancel={this.onCancelOrError}
            onError={this.onCancelOrError}
          />
        )}
        {openedRequestForm && (
          <RequestFormView
            request={buildRequestFormViewModel(openedRequestForm)}
            onClose={() => this.onCloseRequestForm()}
            fromEventTab={fromEventTab}
          />
        )}
      </>
    );
  }
}

export default withTranslation()(EventRequestsContainer);
